import {
  START_LOADING,
  END_LOADING,
  FETCH_SMS_PROVIDERS,
  FETCH_SMS_PROVIDER,
  ADD_SMS_PROVIDER,
  UPDATE_SMS_PROVIDER,
  DELETE_SMS_PROVIDER,
  SMS_PROVIDERS_ERROR,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  smsProviders: [],
  smsProviderById: null,
  error: null,
};

const smsProviders = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true, error: null };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_SMS_PROVIDERS:
      return {
        ...state,
        smsProviders: action.payload.data,
        error: null,
      };
    case FETCH_SMS_PROVIDER:
      return { ...state, smsProviderById: action.payload.data, error: null };
    case ADD_SMS_PROVIDER:
      return {
        ...state,
        smsProviders: [...state.smsProviders, action.payload.data],
        error: null,
      };
    case UPDATE_SMS_PROVIDER:
      return {
        ...state,
        smsProviders: state.smsProviders.map((smsProvider) =>
          smsProvider.name === action.payload.name
            ? action.payload
            : smsProvider
        ),
        error: null,
      };
    case DELETE_SMS_PROVIDER:
      return {
        ...state,
        smsProviders: state.smsProviders.filter(
          (smsProvider) => smsProvider.name !== action.payload
        ),
        error: null,
      };
    case SMS_PROVIDERS_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default smsProviders;
